module.exports = __webpack_public_path__ + "static/media/fourth_prize.56009ffb.png";